// const baseUrl = 'http://192.168.199.6:8000';
// const baseUrl = 'https://ezy.company';
// const baseUrl = 'https://ezycompany.liara.run';
// const baseUrl = 'https://back.ezy.company';
const baseUrl = '';
// const baseUrl = 'http://localhost:62094';
// const baseUrl = 'http://back';

export default baseUrl;